
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import ValuesSection from './components/ValuesSection';
import VisionSection from './components/VisionSection';
import GlobalReachSection from './components/GlobalReachSection';

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-black relative">
      <Header />
      
      <div className="relative">
        <HeroSection />
        <StorySection />
        <VisionSection />
        <ValuesSection />
        <GlobalReachSection />
      </div>
      
      <Footer />
    </div>
  );
};

export default About;
